import { useState } from "react";
import { Menu, X, MessageCircle } from "lucide-react";
import YmfLogo from "./YmfLogo";
import { goTo } from "../lib/scroll";

const LINKS = [
  { id: "#que-es", label: "¿Qué es?", testid: "nav-link-que-es" },
  { id: "#comparador", label: "Antes y después", testid: "nav-link-comparador" },
  { id: "#podcast", label: "Podcast", testid: "nav-link-podcast" },
  { id: "#equipo", label: "Equipo", testid: "nav-link-equipo" },
  { id: "#contacto", label: "Contacto", testid: "nav-link-contacto" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const go = (e, id) => {
    e.preventDefault();
    setOpen(false);
    goTo(id);
  };
  return (
    <header className="fixed top-0 inset-x-0 z-50 bg-[var(--bg)]/90 backdrop-blur-md border-b-2 border-[var(--line)]">
      <div className="max-w-6xl mx-auto px-5 md:px-8 h-16 flex items-center justify-between gap-4">
        <a
          href="#top"
          data-testid="nav-logo"
          onClick={(e) => go(e, "#top")}
          className="flex items-center gap-2.5 shrink-0"
          aria-label="Ye muy fácil: ir al inicio"
        >
          <YmfLogo size={40} withWink={false} />
          <span className="leading-none">
            <span className="font-hand text-2xl block">Ye muy fácil</span>
            <span className="text-[10px] font-bold uppercase tracking-[0.18em] text-[var(--blue-deep)] block mt-0.5">Lectura fácil · Asturias</span>
          </span>
        </a>
        <nav className="hidden md:flex items-center gap-6" aria-label="Navegación principal">
          {LINKS.map((l) => (
            <a
              key={l.id}
              href={l.id}
              data-testid={l.testid}
              onClick={(e) => go(e, l.id)}
              className="text-[15px] font-bold text-[var(--ink)] hover:text-[var(--blue-deep)] transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>
        <div className="flex items-center gap-2">
          <a
            href="https://wa.me/34623409416"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="nav-cta-whatsapp"
            className="hidden sm:inline-flex items-center gap-2 sketch-sm bg-[var(--yellow)] px-4 py-2 text-sm font-bold text-[var(--ink)] hover:-translate-y-0.5 transition-transform shadow-[3px_3px_0_var(--ink)]"
          >
            <MessageCircle className="w-4 h-4" aria-hidden="true" />
            Escríbenos
          </a>
          <button
            data-testid="nav-toggle"
            className="md:hidden p-2"
            aria-label={open ? "Cerrar menú" : "Abrir menú"}
            aria-expanded={open}
            onClick={() => setOpen(!open)}
          >
            {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>
      {open ? (
        <nav className="md:hidden bg-[var(--bg)] border-b-2 border-[var(--ink)] px-5 py-4 flex flex-col gap-4" aria-label="Navegación móvil" data-testid="nav-mobile-menu">
          {LINKS.map((l) => (
            <a key={l.id} href={l.id} data-testid={l.testid + "-mobile"} onClick={(e) => go(e, l.id)} className="text-lg font-bold">
              {l.label}
            </a>
          ))}
        </nav>
      ) : null}
    </header>
  );
}
